module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Pendências de presidente")])])], 1), _vm._v(" "), (_vm.activeMessages.length > 0) ? _c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.activeMessages), function(message, idx) {
    return _c('v-alert', {
      key: 'message_' + idx,
      attrs: {
        "color": message.type,
        "value": "true",
        "dismissible": ""
      },
      model: {
        value: (message.show),
        callback: function($$v) {
          _vm.$set(message, "show", $$v)
        },
        expression: "message.show"
      }
    }, [_vm._v("\n                " + _vm._s(message.text) + "\n            ")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pendenciaDoPresidente.length > 0) ? _c('v-card', {
    staticStyle: {
      "margin": "30px"
    }
  }, _vm._l((_vm.pendenciaDoPresidente), function(pendencias) {
    return _c('v-flex', {
      key: pendencias.banca_id
    }, [(pendencias.ataPendente == true || pendencias.certificacaoPendente == true || pendencias.finalizada == false) ? _c('v-card', [_c('ul', [_c('v-card-title', [_c('b', [_vm._v("Banca:")]), _vm._v(" " + _vm._s(pendencias.banca_id + " - " + pendencias.titulo) + " ")]), _vm._v(" "), _c('v-card-title', [_c('li', {
      staticStyle: {
        "padding": "0 30px 0 0"
      }
    }, [_vm._v("Banca finalizada: "), (pendencias.finalizada) ? _c('v-chip', {
      attrs: {
        "small": "",
        "color": "success",
        "text-color": "white"
      }
    }, [_vm._v("Concluído")]) : _c('v-chip', {
      attrs: {
        "small": "",
        "color": "warning",
        "text-color": "white"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'examDetail',
          params: {
            id: pendencias.banca_id
          }
        }
      }
    }, [_vm._v("Pendente")])], 1)], 1), _vm._v(" "), _c('li', {
      staticStyle: {
        "padding": "0 30px 0 0"
      }
    }, [_vm._v("Certificação: "), (pendencias.certificacaoPendente) ? _c('v-chip', {
      attrs: {
        "small": "",
        "color": "warning",
        "text-color": "white"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showExamAttendance(pendencias.banca)
        }
      }
    }, [_vm._v("Pendente")]) : _c('v-chip', {
      attrs: {
        "small": "",
        "color": "success",
        "text-color": "white"
      }
    }, [_vm._v("Concluído")])], 1), _vm._v(" "), _c('li', [_vm._v("Ata: "), (pendencias.ataPendente) ? _c('v-chip', {
      attrs: {
        "small": "",
        "color": "warning",
        "text-color": "white"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showExamDocuments(pendencias.banca)
        }
      }
    }, [_vm._v("Pendente")]) : _c('v-chip', {
      attrs: {
        "small": "",
        "color": "success",
        "text-color": "white"
      }
    }, [_vm._v("Concluído")])], 1)])], 1)]) : _vm._e()], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Acima estão listadas as bancas que você coordena e que estão com pendências.")])]), _vm._v(" "), _c('fullscreen-spinner'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.evaluationDialog),
      callback: function($$v) {
        _vm.evaluationDialog = $$v
      },
      expression: "evaluationDialog"
    }
  }, [_c('exam-evaluations', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.evaluationDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.attendanceDialog),
      callback: function($$v) {
        _vm.attendanceDialog = $$v
      },
      expression: "attendanceDialog"
    }
  }, [_c('exam-attendance', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.attendanceDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.documentsDialog),
      callback: function($$v) {
        _vm.documentsDialog = $$v
      },
      expression: "documentsDialog"
    }
  }, [_c('exam-documents', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.documentsDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.showDialogBanca),
      callback: function($$v) {
        _vm.showDialogBanca = $$v
      },
      expression: "showDialogBanca"
    }
  }, [_c('exam-documents', [_c('template', {
    slot: "actions"
  }, [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "offset-xs2": "",
      "offset-sm2": "",
      "offset-md2": "",
      "xs10": "",
      "sm10": "",
      "md10": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Cancelar Banca")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "large": "",
      "href": "https://codepen.io/johnjleider/pen/wyYVVj",
      "target": "_blank"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-codepen")])], 1), _vm._v(" "), _c('span', [_vm._v("Codepen")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "record_voice_over",
      "label": "Motivo do cancelamento",
      "type": "text"
    },
    model: {
      value: (_vm.obs_of_situation),
      callback: function($$v) {
        _vm.obs_of_situation = $$v
      },
      expression: "obs_of_situation"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelarBanca(_vm.dialogItem)
      }
    }
  }, [_vm._v("Confirmar Cancelamento")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    style: (_vm.styleButtonDialog),
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.showDialogBanca = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4126b23c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamPendency.vue
// module id = 249
// module chunks = 0